import React from "react";
import { useRouterExtended } from "../hooks/useRouterExtended";
import { useStorageCache } from "../hooks/useStorageCache";
import constants from "@/global/config/constants";
import { useTeamConfig } from "../hooks/useTeamConfig";
import { createState } from "../store/zustand_store";

export const useRepInfoState = createState({
  repName: "",
  repAccountId: "",
});

export function RepInfoCheckerContainer() {
  const { teamSchema } = useTeamConfig();
  const repNameStorage = useStorageCache(constants.repNameStorageKey);
  const repAccountIdStorage = useStorageCache(constants.repAccountIdStorageKey);
  const router = useRouterExtended();
  const urlRepName = router?.query?.repName as string;
  const urlRepAccountId = router?.query?.repAccountId as string;
  const { set: setRepInfoState } = useRepInfoState();
  const storageRepName = repNameStorage?.get(teamSchema);
  const storageRepAccountId = repAccountIdStorage?.get(teamSchema);

  React.useEffect(() => {
    if (urlRepName) {
      let repNameNormalized = normalizeRepName(urlRepName);
      repNameStorage?.set(teamSchema, repNameNormalized);
      setRepInfoState({ repName: repNameNormalized });
    } else if (storageRepName) {
      setRepInfoState({ repName: storageRepName });
    }

    if (urlRepAccountId) {
      const repAccountId = String(urlRepAccountId);
      repAccountIdStorage?.set(teamSchema, repAccountId);
      setRepInfoState({ repAccountId });
    } else if (storageRepAccountId) {
      setRepInfoState({ repAccountId: storageRepAccountId });
    }
  }, []);

  return null;
}

function normalizeRepName(repName: string) {
  let normalized = "";

  if (repName.includes("_")) normalized = repName.replaceAll("_", " ");
  else normalized = repName.replace(" ", "");

  normalized = normalized.trim();
  return normalized;
}
